$(document).ready(function(){
  $('.testimonialSlider').owlCarousel({
    loop:true,
    margin:10,
    autoplay: true,
    autoplayTimeout:6000,
    dots: true,
    nav: true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
        },
        600:{
            items:2,
        },
        1000:{
            items:2,
        }
    }
});
});


$(document).ready(function(){
    $("accordianBtn.block-1").click(function(){
        $(".block-1").toggleClass("blockss-1");
 
    });
});

$(document).ready(function(){
    $(".accordianBtn.block-2").click(function(){
        $(".block-2").toggleClass("blockss-1");

   
    });
});

$(document).ready(function(){
    $(".accordianBtn.block-3").click(function(){
        $(".accordianBtn.block-3").toggleClass("blockss-1");
   ;
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-4").click(function(){
        $(".accordianBtn.block-4").toggleClass("blockss-1");
   ;
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-5").click(function(){
        $(".accordianBtn.block-5").toggleClass("blockss-1");
   ;
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-6").click(function(){
        $(".accordianBtn.block-6").toggleClass("blockss-1");
   ;
    });
});$(document).ready(function(){
    $(".accordianBtn.block-7").click(function(){
        $(".accordianBtn.block-7").toggleClass("blockss-1");
   ;
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-8").click(function(){
           $(".accordianBtn.block-8").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-9").click(function(){
           $(".accordianBtn.block-9").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-10").click(function(){
           $(".accordianBtn.block-10").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-10").click(function(){
           $(".accordianBtn.block-11").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-11").click(function(){
           $(".accordianBtn.block-11").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-12").click(function(){
           $(".accordianBtn.block-12").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-13").click(function(){
           $(".accordianBtn.block-13").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-14").click(function(){
           $(".accordianBtn.block-14").toggleClass("blockss-1");
    });
});
$(document).ready(function(){
    $(".accordianBtn.block-15").click(function(){
           $(".accordianBtn.block-15").toggleClass("blockss-1");
    });
});


  var deskSlideToShow = $(".ftCollectionContainer").attr("data-slide");
  var finalDeskSlideToShow = parseInt(deskSlideToShow);

  var productSliderContainer = $(".productSliderContainer");
  productSliderContainer.owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    items: finalDeskSlideToShow,
  });

  $(".deskNext").click(function () {
    productSliderContainer.trigger("next.owl.carousel");
  });

  $(".deskPrev").click(function () {
    productSliderContainer.trigger("prev.owl.carousel");
  });

  // for mobile settings
  var slideToShow = $(".ftCollectionContainerMob").attr("data-slide");
  var finalSlideToShow = parseInt(slideToShow);
  var productSliderContainerMob = $(".productSliderContainerMob");
  productSliderContainerMob.owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    items: finalSlideToShow,
  });

  $(".mobNext").click(function () {
    productSliderContainerMob.trigger("next.owl.carousel");
  });

  $(".mobPrev").click(function () {
    productSliderContainerMob.trigger("prev.owl.carousel");
  });

  productSliderContainer.on("changed.owl.carousel", function (e) {
    $(".deskNext").removeClass("disabledBtn");
    $(".deskPrev").removeClass("disabledBtn");
  });
  productSliderContainerMob.on("changed.owl.carousel", function (e) {
    $(".mobPrev").removeClass("disabledBtn");
    $(".mobNext").removeClass("disabledBtn");
    
  });


function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
$(".sidebarIconToggle").click(function(){
  $("#template-customers-account").css("height","0");
});






